import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '../default';

import { getJMCTemplateList } from './actions';
import { TemplateState } from './types';

export default createReducer(initialState as TemplateState, builder => {
  builder
    .addCase(getJMCTemplateList.pending, state => {
      state.pending = true;
    })
    .addCase(getJMCTemplateList.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload;
    })
    .addCase(getJMCTemplateList.rejected, state => {
      state.pending = false;
      state.error = true;
    });
});
